import {useEffect, useState} from "react";

function usePageFocused() {
    const [focused, setFocused] = useState(
      typeof document !== "undefined" &&
      !document.hidden &&
      document.hasFocus()
    );

    useEffect(() => {
        const onFocus = () => setFocused(true);
        const onBlur = () => setFocused(false);

        const onVisibilityChange = () => {
            setFocused(!document.hidden && document.hasFocus());
        };

        window.addEventListener("focus", onFocus);
        window.addEventListener("blur", onBlur);
        document.addEventListener("visibilitychange", onVisibilityChange);

        return () => {
            window.removeEventListener("focus", onFocus);
            window.removeEventListener("blur", onBlur);
            document.removeEventListener("visibilitychange", onVisibilityChange);
        };
    }, []);

    return focused;
}

export default usePageFocused
